<script setup>
import { computed, onMounted } from "vue";
import { useRoute, RouterLink } from "vue-router";
import { useScrollStore } from "@/stores/storeScroll";

const route = useRoute();
const storeScroll = useScrollStore();

const isNotFinedPage = computed(() => route.name === "404");
onMounted(() => {});
</script>
<template>
	<section class="not-page" :style="{ paddingTop: storeScroll.header?.offsetHeight + 'px' }">
		<div class="container">
			<div class="not-page__container">
				<div class="not-page__numbers">
					<span>4</span>
					<span>0</span>
					<span>4</span>
				</div>
				<h1 class="not-page__title">Страница не найдена</h1>
				<p class="not-page__text">К сожалению, такой страницы не существует или она удалена.</p>
				<RouterLink to="/" class="not-page__btn btn --small">На главную</RouterLink>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.not-page {
	position: relative;
	background-image: url("@/assets/img/main/main_bg.webp");
	background-repeat: no-repeat;
	background-position: center; /* x y*/
	background-size: cover; /* w h*/

	@media (max-width: vars.$xx) {
		background-image: url("@/assets/img/main/main_bg_mobile.webp");
	}
	&::before {
		position: absolute;
		content: "";
		background-image: url("@/assets/img/main/main_line_bg.webp");
		background-repeat: no-repeat;
		background-size: contain; /* w h*/
		width: 65rem;
		height: 21.5rem;
		bottom: 0;
		right: 0;
		@media (max-width: vars.$xx) {
			width: 64rem;
		}
		@media (max-width: vars.$x480) {
			width: 21rem;
			height: 7rem;
		}
	}
}

.not-page__container {
	position: relative;
	padding: 14.5rem 0 31.4rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5rem;
	@media (max-width: vars.$xx) {
		gap: 2rem;
        padding: 5rem 0 10rem;
	}
}
.not-page__title {
	position: relative;
	font-weight: 700;
	font-size: 7.2rem;
	line-height: 140%;
	text-transform: uppercase;
	color: #fff;
    @media (max-width: vars.$mn) {
        font-size: 5.2rem;
    }
    @media (max-width: vars.$xx) {
        font-size: 3.2rem;
    }
    @media (max-width: vars.$x480) {
        font-size: 2.2rem;
    }
}
.not-page__text {
	position: relative;
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	text-align: center;
	color: #fff;
    @media (max-width: vars.$xx) {
        font-size: 2rem;
    }
    @media (max-width: vars.$x480) {
        font-size: 1.8rem;
    }
}
.not-page__btn {
	padding-left: 3rem;
	padding-right: 3rem;
	@media (max-width: vars.$x480) {
	}
}
.not-page__numbers {
	position: absolute;
	transform: translateY(-19%);

	span {
		font-weight: 700;
		font-size: 56.7rem;
		line-height: 100%;
		text-transform: uppercase;
		color: rgba(12, 76, 163, 0.24);
        -webkit-text-stroke: 1px rgba(255, 255, 255, .25);
        @media (max-width: vars.$mn) {
            font-size: 36.7rem;
        }
        @media (max-width: vars.$xx) {
            font-size: 26.7rem;
        }
        @media (max-width: vars.$x480) {
            font-size: 16.7rem;
        }
	}
}
</style>
